


















/// <reference types="stripe-v3" />
import { Component, Vue, Prop } from "vue-property-decorator";
import { functions } from "@/firebase";

const stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
const elements = stripe.elements();

const style = {
  base: {
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};
const card = elements.create("card", { style: style });

@Component
export default class StripeCard extends Vue {
  cardErrors? = "";

  @Prop({ required: false, default: "subscribe" })
  action!: string;

  mounted() {
    card.mount(this.$refs.card);
  }

  beforeDestroy() {
    card.unmount();
  }

  async createCustomer() {
    await functions.httpsCallable("createCustomer")();
  }

  submitForm() {
    if (this.action == "subscribe") {
      return this.subscribe();
    } else if (this.action == "updatePayment") {
      return this.updatePayment();
    }
  }

  async subscribe() {
    this.$store.commit("setLoading");
    await this.createCustomer();

    const result = await stripe.createPaymentMethod({
      type: "card",
      card: card,
    });
    if (result.error) {
      this.cardErrors = result.error.message;
    } else if (result.paymentMethod) {
      this.cardErrors = "";
      const resp = await functions.httpsCallable("subscribe")(result.paymentMethod.id);
      if (resp.data.success) {
        const latestInvoice = resp.data.subscription.latest_invoice;
        const paymentIntent = latestInvoice.payment_intent;
        if (paymentIntent) {
          const clientSecret = paymentIntent.client_secret;
          const status = paymentIntent.status;
          if (status === "requires_action") {
            const result = await stripe.confirmCardPayment(clientSecret);
            if (result.error) {
              this.cardErrors = result.error.message;
            }
          }
        }
      }
    }
    card.clear();
    this.$store.commit("setNotLoading");
  }

  async updatePayment() {
    this.$store.commit("setLoading");
    const result = await stripe.createPaymentMethod({
      type: "card",
      card: card,
    });
    if (result.error) {
      this.cardErrors = result.error.message;
    } else if (result.paymentMethod) {
      this.cardErrors = "";
      const resp = await functions.httpsCallable("updatePayment")(result.paymentMethod.id);
      console.log(resp);
    }
    card.clear();
    this.$store.commit("setNotLoading");
  }
}
